import { parseElementFromString } from 'anodum';
import globals from '../../../globals';
import findBlockSettingComments from './find-block-setting-comments';
import { BLOCK_SETTING_COMMENT } from '../../constants/regexp';
import commentsToTemplates from './comments-to-templates';
import templatesToComments from './templates-to-comments';

const disableElement = (container, childrenSelector, blockSettingId = null) => {
  const targetChildren = container.querySelectorAll(childrenSelector);

  /**
   *  TODO: hasAdditives flag isn't being updated during conversion to node
   *
   *  At the moment we don't have an ability to check if element has additives.
   *  By default, each comment contains `hasAdditives` state, after converting comment to the
   *  dom node, state of `additives` will be lost:
   *
   *  <!--{.selector}{false}{<span class="test">test</span>}-->
   *
   *  Will be replaced by:
   *
   *  <span class="test">test</span>
   *
   *  Since already injected span isn't processed by HDRM (it doesn't have `data-ws-id`,
   *  <!-- ws-static-text-token --> comment for text node, and etc) we can't verify if element
   *  has additives when we try to make reverse conversion, and whole injected node will look like
   *  a mutation.
   * */

  targetChildren.forEach((child) => {
    const cloneNode = child.cloneNode(true);
    globals.helpers.ejectGlobals(cloneNode);
    const commentNode = document.createComment(
      `{${childrenSelector}}{false}{${commentsToTemplates(cloneNode).outerHTML}}{${blockSettingId}}`
    );

    child.parentNode.replaceChild(commentNode, child);
  });
};

const enableElement = (container, childrenSelector) => {
  const commentedSetting = findBlockSettingComments(container, childrenSelector);

  commentedSetting.forEach((targetNode) => {
    const targetNodeValue = targetNode.nodeValue;
    const targetHtml = targetNodeValue.match(BLOCK_SETTING_COMMENT)[2];
    const commentedDom = parseElementFromString(targetHtml);

    globals.helpers.injectGlobals(commentedDom);
    targetNode.parentNode.replaceChild(templatesToComments(commentedDom), targetNode);
  });
};

const updateChildrenPresence = (element, childrenSelector, isEnabled, blockSettingId) => {
  if (!element) return;

  if (isEnabled) {
    enableElement(element, childrenSelector);
  } else {
    disableElement(element, childrenSelector, blockSettingId);
  }
};

export default updateChildrenPresence;
